import { useContext } from 'react';
import { Link } from 'react-router-dom';
import MyContext from '../context/MyContext';
import texts from '../services/texts';
import SwitchLinguage from './SwitchLinguage';

function Menu() {
  const { language } = useContext(MyContext);

  return (
    <div className="side-menu">
      <Link to="/">
        <p className="menu">Home</p>
      </Link>
      <Link to="/about">
        <p className="menu">{texts.menu[language].About}</p>
      </Link>
      <Link to="/projects">
        <p className="menu">{texts.menu[language].Projects}</p>
      </Link>
      <Link to="/contact">
        <p className="menu">{texts.menu[language].Contact}</p>
      </Link>
      <SwitchLinguage />
    </div>
  );
}

export default Menu;
